import { Alert as AntdAlert } from "antd"
import cx from "clsx"
import styles from "./index.module.less"

const Alert = props => {
  const { className } = props
  return <AntdAlert className={cx(className, styles.alert)} {...props}></AntdAlert>
}

export default Alert
